import tippy, { followCursor } from "tippy.js"
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.instances = []
    const segments = this.element.querySelectorAll("[data-donut-tooltip]")

    segments.forEach((segment) => {
      const instance = tippy(segment, {
        content: segment.getAttribute("data-donut-tooltip"),
        followCursor: true,
        plugins: [followCursor],
        popperOptions: { strategy: "fixed" },
      })
      this.instances.push(instance)
    })
  }

  disconnect() {
    this.instances.forEach((instance) => instance.destroy())
    this.instances = []
  }
}
